import axios from 'axios';
import BaseAPI from './base/base-api';

class ContactAdditionalAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'contactadditional';
}

export default new ContactAdditionalAPI();
